/**
 * Get Error Message From Concatenated JSON
 */
export default function getErrorMessageFromConcatenatedJSON(raw) {
  if (raw.error) {
    throw new Error(raw.message);
  }

  let errorMessage = null;
  let matches;
  try {
    matches = raw.match(/{[^}]+}/g); // Rough split based on object-like structure
  } catch (_) {
    return errorMessage;
  }

  matches?.some((jsonString) => {
    try {
      const object = JSON.parse(jsonString);
      if (object.error === true) {
        errorMessage = object.message || 'Unknown error';
        return true; // Stop the loop
      }
    } catch (_) {
      console.error('Invalid JSON:', jsonString);
    }
    return false;
  });

  if (errorMessage) {
    throw new Error(errorMessage);
  }
  return errorMessage;
}
